<mat-card-content
  [style.display]="dataSource.filteredData.length !== 0 ? 'block' : 'none'"
  style="padding: 36px"
>
  <div class="table-responsive" tabindex="0">
    <table mat-table class="table-responsive" [dataSource]="dataSource">
      <ng-container matColumnDef="day">
        <th
          class="f-w-600 f-s-15 custom-column"
          mat-header-cell
          *matHeaderCellDef
        >
          Día
        </th>
        <td
          class="f-s-14 custom-column"
          mat-cell
          *matCellDef="let item"
          [ngClass]="{ 'border-bottom-class': item.nextIsDifferent === true }"
        >
          {{ item.day }}
        </td>
        <td mat-footer-cell *matFooterCellDef class="custom-column cuenta"></td>
      </ng-container>
      <ng-container matColumnDef="fechaServicio">
        <th
          class="f-w-600 f-s-15 custom-column"
          mat-header-cell
          *matHeaderCellDef
        >
          Fecha
        </th>
        <td
          class="f-s-14 custom-column"
          mat-cell
          *matCellDef="let item"
          [ngClass]="{ 'border-bottom-class': item.nextIsDifferent === true }"
        >
          {{ item.fechaServicio }}
        </td>
        <td
          class="f-s-14 custom-column"
          mat-footer-cell
          *matFooterCellDef
          class="custom-column cuenta"
        ></td>
      </ng-container>

      <ng-container matColumnDef="actividad">
        <th
          class="f-w-600 f-s-15 custom-column"
          mat-header-cell
          *matHeaderCellDef
        >
          Actividad
        </th>
        <td
          class="f-s-14 custom-column"
          mat-cell
          *matCellDef="let item"
          [ngClass]="{ 'border-bottom-class': item.nextIsDifferent === true }"
        >
          {{ item.objProducto?.nombre }}
        </td>
        <td class="f-s-14 custom-column" mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="servicio">
        <th
          class="f-w-600 f-s-15 custom-column"
          mat-header-cell
          *matHeaderCellDef
        >
          Servicio
        </th>
        <td
          class="f-s-14 custom-column"
          mat-cell
          *matCellDef="let item"
          [ngClass]="{ 'border-bottom-class': item.nextIsDifferent === true }"
        >
          {{ item?.nombreServicio || '-' }}
        </td>
        <td class="f-s-14 custom-column" mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="menu">
        <th
          class="f-w-600 f-s-15 custom-column"
          mat-header-cell
          *matHeaderCellDef
        >
          Menú
        </th>
        <td
          class="f-s-14 custom-column"
          mat-cell
          *matCellDef="let item"
          [ngClass]="{ 'border-bottom-class': item.nextIsDifferent === true }"
        >
          {{
            item.menu?.nombreMenu
              ? item.menu?.nombreMenu
              : 'No tiene menú asignado'
          }}
        </td>
        <td class="f-s-14 custom-column" mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="cantPAX">
        <th
          class="f-w-600 f-s-15 custom-column"
          mat-header-cell
          *matHeaderCellDef
        >
          Pax
        </th>
        <td
          class="f-s-14 custom-column"
          mat-cell
          *matCellDef="let item"
          [ngClass]="{ 'border-bottom-class': item.nextIsDifferent === true }"
        >
          {{ handleCero(item.cantPAX) }}
        </td>
        <td class="f-s-14 custom-column" mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="tc">
        <th
          class="f-w-600 f-s-15 custom-column"
          mat-header-cell
          *matHeaderCellDef
        >
          TC
        </th>
        <td
          class="f-s-14 custom-column"
          mat-cell
          *matCellDef="let item"
          [ngClass]="{ 'border-bottom-class': item.nextIsDifferent === true }"
        >
          {{ handleCero(item.tc) }}
        </td>
        <td class="f-s-14 custom-column" mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="totalGuiaAYB">
        <th
          class="f-w-600 f-s-15 custom-column"
          mat-header-cell
          *matHeaderCellDef
        >
          Guia
        </th>
        <td
          class="f-s-14 custom-column"
          mat-cell
          *matCellDef="let item; let i = index"
          [ngClass]="{ 'border-bottom-class': item.nextIsDifferent === true }"
        >
          {{ handleCero(item.totalGuiaAYB) }}
        </td>
        <td class="f-s-14 custom-column" mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <ng-container matColumnDef="totalChoferAYB">
        <th
          class="f-w-600 f-s-15 custom-column"
          mat-header-cell
          *matHeaderCellDef
        >
          Chofer
        </th>
        <td
          class="f-s-14 custom-column"
          mat-cell
          *matCellDef="let item; let i = index"
          [ngClass]="{ 'border-bottom-class': item.nextIsDifferent === true }"
        >
          {{ handleCero(item.totalChoferAYB) }}
        </td>
        <td class="f-s-14 custom-column" mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <ng-container matColumnDef="totalesPersonalCampoAYB">
        <th
          class="f-w-600 f-s-15 custom-column"
          mat-header-cell
          *matHeaderCellDef
        >
          A.P. + B. + Coc. + P.C
        </th>
        <td
          class="f-s-14 custom-column"
          mat-cell
          *matCellDef="let item; let i = index"
          [ngClass]="{ 'border-bottom-class': item.nextIsDifferent === true }"
        >
          <div style="width: 100%; display: flex; flex-direction: row">
            <div style="max-width: 70px; width: 70px">
              {{ handleCero(item.totalesPersonalCampoAYB) }}
            </div>
            <div style="width: 30px">
              <button
                mat-icon-button
                color="primary"
                (click)="
                  openDialogEditTotalPax(item, 'totalesPersonalCampoAYB')
                "
              >
                <i-tabler name="pencil" class="icon-20"></i-tabler>
              </button>
            </div>
          </div>
        </td>
        <td class="f-s-14 custom-column" mat-footer-cell *matFooterCellDef>
          Total File
        </td>
      </ng-container>

      <ng-container matColumnDef="totalMenuXFilaAYB">
        <th
          class="f-w-600 f-s-15 custom-column"
          mat-header-cell
          *matHeaderCellDef
        >
          Total
        </th>

        <td
          class="f-s-14 custom-column"
          mat-cell
          *matCellDef="let item; let i = index"
          [ngClass]="{ 'border-bottom-class': item.nextIsDifferent === true }"
        >
          <div class="total-fila">
            {{ handleCero(item.totalMenuXFilaAYB) }}
          </div>
        </td>
        <td
          class="f-s-14 custom-column"
          mat-footer-cell
          *matFooterCellDef
          style="font-weight: 600; color: #303030"
        >
          <div class="total-fila">
            {{ totalMenus }}
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="observacionAYB">
        <th
          class="f-w-600 f-s-15 custom-column"
          mat-header-cell
          *matHeaderCellDef
          class="column-160"
        >
          Observación
        </th>
        <td
          class="f-s-14 custom-column"
          mat-cell
          *matCellDef="let serviceRow; let i = index"
          [ngClass]="{
            'border-bottom-class': serviceRow.nextIsDifferent === true
          }"
        >
          <div class="row" style="width: 100%; gap: 10px">
            <div style="max-width: 128px; width: 128px">
              {{ serviceRow?.observacionAYB || '-' }}
            </div>
            <div style="width: fit-content">
              <button
                mat-icon-button
                (click)="openDialogEditObservacion(serviceRow)"
                class="icon-Active"
              >
                <i-tabler name="pencil" class="icon-20"></i-tabler>
              </button>
            </div>
          </div>
        </td>
        <td class="f-s-14 custom-column" mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="asignar">
        <th
          class="f-w-600 f-s-15 custom-column"
          mat-header-cell
          *matHeaderCellDef
        >
          Insumos
        </th>
        <td
          class="f-s-14 custom-column"
          mat-cell
          *matCellDef="let row"
          [ngClass]="{ 'border-bottom-class': row.nextIsDifferent === true }"
        >
          <div class="center-div row-base gap-8" style="width: 100%">
            <button
              mat-icon-button
              (click)="row.menu?.nombreMenu ? openDialogInsumos(row) : null"
              [disabled]="!row.menu?.nombreMenu"
              [ngClass]="{
                'icon-Active': row.menu?.nombreMenu,
                'icon-blocked': !row.menu?.nombreMenu
              }"
            >
              <i-tabler name="paper-bag" class="icon-20"></i-tabler>
            </button>
            <span matTooltip="Insumo Retirado" matTooltipPosition="above">
              <i-tabler
                *ngIf="row?.confirmInsumosAYB"
                name="circle-check"
                class="icon-24 icon-full-green"
              ></i-tabler>
            </span>
          </div>
        </td>
        <td class="f-s-14 custom-column" mat-footer-cell *matFooterCellDef></td>
      </ng-container>
      <ng-container matColumnDef="file">
        <th
          class="f-w-600 f-s-15 custom-column"
          mat-header-cell
          *matHeaderCellDef
        >
          Archivo
        </th>
        <td
          class="f-s-14 custom-column"
          mat-cell
          *matCellDef="let serviceRow; let i = index"
          [ngClass]="{
            'border-bottom-class': serviceRow.nextIsDifferent === true
          }"
        >
          <div class="center-div" style="width: 100%">
            <button
              mat-icon-button
              [color]="serviceRow?.confirmPDFAYB ? 'primary' : null"
              [disabled]="!serviceRow?.confirmPDFAYB"
              (click)="
                serviceRow?.confirmPDFAYB
                  ? openDialogMultimedia(serviceRow)
                  : null
              "
              [ngClass]="{
                'icon-Active': serviceRow.confirmPDFAYB,
                'icon-blocked': !serviceRow.confirmPDFAYB
              }"
            >
              <i-tabler name="file-type-pdf" class="icon-20"></i-tabler>
            </button>
          </div>
        </td>
        <td class="f-s-14 custom-column" mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr mat-footer-row *matFooterRowDef="displayedColumns; sticky: true"></tr>
    </table>
  </div>
</mat-card-content>
